/* eslint-disable react-hooks/rules-of-hooks */
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { ThemeType } from '@/stores/builder';
import { BaseCart } from '@/types/http/cart/common';
import React from 'react';

export interface BadgeCartProps {
  theme: ThemeType;
  item: BaseCart;
}

export default function BadgeStoreFront({ theme, item }: BadgeCartProps) {
  const discountPercentage = React.useMemo(() => {
    const getDiscount = (sellPrice?: number, discountPrice?: number) => {
      return sellPrice && discountPrice ? ((sellPrice - discountPrice) / sellPrice) * 100 : 0;
    };

    return getDiscount(item?.sell_price, item?.discount_price);
  }, [item, item?.sell_price, item?.discount_price]);

  const BADGES_PRODUCT = [
    item.best_seller && {
      text: theme?.badge?.bestSellerText || 'Best Seller',
      className:
        theme?.badge?.position === 'inside'
          ? 'theme_badge_best_seller_gradient'
          : 'theme_badge_best_seller',
    },
    item?.new_arrival && {
      text: theme?.badge?.newArrivalText || 'New Arrival',
      className:
        theme?.badge?.position === 'inside'
          ? 'theme_badge_new_arrival_gradient'
          : 'theme_badge_new_arrival',
    },
    discountPercentage > 0 && {
      text: `${theme?.badge?.promotionText || 'Discount'} ${discountPercentage.toFixed(0)}%`,
      className:
        theme?.badge?.position === 'inside'
          ? 'theme_badge_promotion_gradient'
          : 'theme_badge_promotion',
    },
  ].filter(Boolean) as { text: string; className: string }[];
  return (
    <div className=''>
      {BADGES_PRODUCT.length > 0 && (
        <div
          className={cn(
            'grid w-full gap-2',
            BADGES_PRODUCT.length === 1 ? 'grid-cols-1' : '',
            BADGES_PRODUCT.length === 2 ? 'grid-cols-2' : '',
            BADGES_PRODUCT.length === 3 ? 'grid-cols-2 grid-rows-2' : ''
          )}
        >
          {BADGES_PRODUCT.map((badge, index) => (
            <Badge
              key={index}
              variant='custom'
              className={cn(
                'theme_badge_inside w-full text-[12px] font-bold',
                badge.className,
                BADGES_PRODUCT.length === 3 && index === 2 ? 'col-span-2' : ''
              )}
            >
              {badge.text}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
